// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_auth_room.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ParticipantInfo } from "./livekit_models_pb";
import { file_livekit_models } from "./livekit_models_pb";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { NatsSystemNotificationTypes } from "./plugnmeet_nats_msg_pb";
import { file_plugnmeet_nats_msg } from "./plugnmeet_nats_msg_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_auth_room.proto.
 */
export const file_plugnmeet_auth_room: GenFile = /*@__PURE__*/
  fileDesc("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", [file_livekit_models, file_buf_validate_validate, file_plugnmeet_common_api, file_plugnmeet_nats_msg]);

/**
 * @generated from message plugnmeet.GetActiveRoomInfoReq
 */
export type GetActiveRoomInfoReq = Message<"plugnmeet.GetActiveRoomInfoReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.GetActiveRoomInfoReq.
 * Use `create(GetActiveRoomInfoReqSchema)` to create a new message.
 */
export const GetActiveRoomInfoReqSchema: GenMessage<GetActiveRoomInfoReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 0);

/**
 * @generated from message plugnmeet.ActiveRoomInfoRes
 */
export type ActiveRoomInfoRes = Message<"plugnmeet.ActiveRoomInfoRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional plugnmeet.ActiveRoomInfo room_info = 4;
   */
  roomInfo?: ActiveRoomInfo | undefined;

  /**
   * @generated from field: repeated livekit.ParticipantInfo participants_info = 5;
   */
  participantsInfo: ParticipantInfo[];
};

/**
 * Describes the message plugnmeet.ActiveRoomInfoRes.
 * Use `create(ActiveRoomInfoResSchema)` to create a new message.
 */
export const ActiveRoomInfoResSchema: GenMessage<ActiveRoomInfoRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 1);

/**
 * @generated from message plugnmeet.ActiveRoomInfo
 */
export type ActiveRoomInfo = Message<"plugnmeet.ActiveRoomInfo"> & {
  /**
   * @generated from field: string room_title = 1;
   */
  roomTitle: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string sid = 3;
   */
  sid: string;

  /**
   * @generated from field: int64 joined_participants = 4 [jstype = JS_STRING];
   */
  joinedParticipants: string;

  /**
   * @generated from field: int32 is_running = 5;
   */
  isRunning: number;

  /**
   * @generated from field: int32 is_recording = 6;
   */
  isRecording: number;

  /**
   * @generated from field: int32 is_active_rtmp = 7;
   */
  isActiveRtmp: number;

  /**
   * @generated from field: string webhook_url = 8;
   */
  webhookUrl: string;

  /**
   * @generated from field: int32 is_breakout_room = 9;
   */
  isBreakoutRoom: number;

  /**
   * @generated from field: string parent_room_id = 10;
   */
  parentRoomId: string;

  /**
   * @generated from field: int64 creation_time = 11 [jstype = JS_STRING];
   */
  creationTime: string;

  /**
   * @generated from field: string metadata = 12;
   */
  metadata: string;
};

/**
 * Describes the message plugnmeet.ActiveRoomInfo.
 * Use `create(ActiveRoomInfoSchema)` to create a new message.
 */
export const ActiveRoomInfoSchema: GenMessage<ActiveRoomInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 2);

/**
 * @generated from message plugnmeet.RoomEndReq
 */
export type RoomEndReq = Message<"plugnmeet.RoomEndReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.RoomEndReq.
 * Use `create(RoomEndReqSchema)` to create a new message.
 */
export const RoomEndReqSchema: GenMessage<RoomEndReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 3);

/**
 * @generated from message plugnmeet.RoomEndRes
 */
export type RoomEndRes = Message<"plugnmeet.RoomEndRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.RoomEndRes.
 * Use `create(RoomEndResSchema)` to create a new message.
 */
export const RoomEndResSchema: GenMessage<RoomEndRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 4);

/**
 * @generated from message plugnmeet.IsRoomActiveReq
 */
export type IsRoomActiveReq = Message<"plugnmeet.IsRoomActiveReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.IsRoomActiveReq.
 * Use `create(IsRoomActiveReqSchema)` to create a new message.
 */
export const IsRoomActiveReqSchema: GenMessage<IsRoomActiveReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 5);

/**
 * @generated from message plugnmeet.IsRoomActiveRes
 */
export type IsRoomActiveRes = Message<"plugnmeet.IsRoomActiveRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: bool is_active = 4;
   */
  isActive: boolean;
};

/**
 * Describes the message plugnmeet.IsRoomActiveRes.
 * Use `create(IsRoomActiveResSchema)` to create a new message.
 */
export const IsRoomActiveResSchema: GenMessage<IsRoomActiveRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 6);

/**
 * @generated from message plugnmeet.ActiveRoomWithParticipant
 */
export type ActiveRoomWithParticipant = Message<"plugnmeet.ActiveRoomWithParticipant"> & {
  /**
   * @generated from field: optional plugnmeet.ActiveRoomInfo room_info = 3;
   */
  roomInfo?: ActiveRoomInfo | undefined;

  /**
   * @generated from field: repeated livekit.ParticipantInfo participants_info = 4;
   */
  participantsInfo: ParticipantInfo[];
};

/**
 * Describes the message plugnmeet.ActiveRoomWithParticipant.
 * Use `create(ActiveRoomWithParticipantSchema)` to create a new message.
 */
export const ActiveRoomWithParticipantSchema: GenMessage<ActiveRoomWithParticipant> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 7);

/**
 * @generated from message plugnmeet.GetActiveRoomInfoRes
 */
export type GetActiveRoomInfoRes = Message<"plugnmeet.GetActiveRoomInfoRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.ActiveRoomWithParticipant room = 4;
   */
  room?: ActiveRoomWithParticipant | undefined;
};

/**
 * Describes the message plugnmeet.GetActiveRoomInfoRes.
 * Use `create(GetActiveRoomInfoResSchema)` to create a new message.
 */
export const GetActiveRoomInfoResSchema: GenMessage<GetActiveRoomInfoRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 8);

/**
 * @generated from message plugnmeet.GetActiveRoomsInfoRes
 */
export type GetActiveRoomsInfoRes = Message<"plugnmeet.GetActiveRoomsInfoRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: repeated plugnmeet.ActiveRoomWithParticipant rooms = 4;
   */
  rooms: ActiveRoomWithParticipant[];
};

/**
 * Describes the message plugnmeet.GetActiveRoomsInfoRes.
 * Use `create(GetActiveRoomsInfoResSchema)` to create a new message.
 */
export const GetActiveRoomsInfoResSchema: GenMessage<GetActiveRoomsInfoRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 9);

/**
 * @generated from message plugnmeet.PastRoomInfo
 */
export type PastRoomInfo = Message<"plugnmeet.PastRoomInfo"> & {
  /**
   * @generated from field: string room_title = 1;
   */
  roomTitle: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 3;
   */
  roomSid: string;

  /**
   * @generated from field: int64 joined_participants = 4 [jstype = JS_STRING];
   */
  joinedParticipants: string;

  /**
   * @generated from field: string webhook_url = 5;
   */
  webhookUrl: string;

  /**
   * @generated from field: string created = 6;
   */
  created: string;

  /**
   * @generated from field: string ended = 7;
   */
  ended: string;

  /**
   * @generated from field: optional string analytics_file_id = 8;
   */
  analyticsFileId?: string | undefined;
};

/**
 * Describes the message plugnmeet.PastRoomInfo.
 * Use `create(PastRoomInfoSchema)` to create a new message.
 */
export const PastRoomInfoSchema: GenMessage<PastRoomInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 10);

/**
 * @generated from message plugnmeet.FetchPastRoomsReq
 */
export type FetchPastRoomsReq = Message<"plugnmeet.FetchPastRoomsReq"> & {
  /**
   * @generated from field: repeated string room_ids = 1;
   */
  roomIds: string[];

  /**
   * @generated from field: uint32 from = 2;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;
};

/**
 * Describes the message plugnmeet.FetchPastRoomsReq.
 * Use `create(FetchPastRoomsReqSchema)` to create a new message.
 */
export const FetchPastRoomsReqSchema: GenMessage<FetchPastRoomsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 11);

/**
 * @generated from message plugnmeet.FetchPastRoomsResult
 */
export type FetchPastRoomsResult = Message<"plugnmeet.FetchPastRoomsResult"> & {
  /**
   * @generated from field: int64 total_rooms = 1 [jstype = JS_STRING];
   */
  totalRooms: string;

  /**
   * @generated from field: uint32 from = 2;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * @generated from field: repeated plugnmeet.PastRoomInfo rooms_list = 5;
   */
  roomsList: PastRoomInfo[];
};

/**
 * Describes the message plugnmeet.FetchPastRoomsResult.
 * Use `create(FetchPastRoomsResultSchema)` to create a new message.
 */
export const FetchPastRoomsResultSchema: GenMessage<FetchPastRoomsResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 12);

/**
 * @generated from message plugnmeet.FetchPastRoomsRes
 */
export type FetchPastRoomsRes = Message<"plugnmeet.FetchPastRoomsRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.FetchPastRoomsResult result = 4;
   */
  result?: FetchPastRoomsResult | undefined;
};

/**
 * Describes the message plugnmeet.FetchPastRoomsRes.
 * Use `create(FetchPastRoomsResSchema)` to create a new message.
 */
export const FetchPastRoomsResSchema: GenMessage<FetchPastRoomsRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 13);

/**
 * @generated from message plugnmeet.GetClientFilesRes
 */
export type GetClientFilesRes = Message<"plugnmeet.GetClientFilesRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: repeated string css = 4 [deprecated = true];
   * @deprecated
   */
  css: string[];

  /**
   * @generated from field: repeated string js = 5 [deprecated = true];
   * @deprecated
   */
  js: string[];

  /**
   * @generated from field: repeated string css_files = 6;
   */
  cssFiles: string[];

  /**
   * @generated from field: repeated string js_files = 7;
   */
  jsFiles: string[];

  /**
   * @generated from field: optional string static_assets_path = 8;
   */
  staticAssetsPath?: string | undefined;
};

/**
 * Describes the message plugnmeet.GetClientFilesRes.
 * Use `create(GetClientFilesResSchema)` to create a new message.
 */
export const GetClientFilesResSchema: GenMessage<GetClientFilesRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 14);

/**
 * @generated from message plugnmeet.BroadcastToRoomReq
 */
export type BroadcastToRoomReq = Message<"plugnmeet.BroadcastToRoomReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: bool only_to_admins = 2;
   */
  onlyToAdmins: boolean;

  /**
   * @generated from field: optional string to_user_id = 3;
   */
  toUserId?: string | undefined;

  /**
   * @generated from oneof plugnmeet.BroadcastToRoomReq.payload
   */
  payload: {
    /**
     * @generated from field: plugnmeet.BroadcastToRoomChatMessage chat_msg = 4;
     */
    value: BroadcastToRoomChatMessage;
    case: "chatMsg";
  } | {
    /**
     * @generated from field: plugnmeet.BroadcastToRoomNotificationMsg notification_msg = 5;
     */
    value: BroadcastToRoomNotificationMsg;
    case: "notificationMsg";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message plugnmeet.BroadcastToRoomReq.
 * Use `create(BroadcastToRoomReqSchema)` to create a new message.
 */
export const BroadcastToRoomReqSchema: GenMessage<BroadcastToRoomReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 15);

/**
 * @generated from message plugnmeet.BroadcastToRoomChatMessage
 */
export type BroadcastToRoomChatMessage = Message<"plugnmeet.BroadcastToRoomChatMessage"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message plugnmeet.BroadcastToRoomChatMessage.
 * Use `create(BroadcastToRoomChatMessageSchema)` to create a new message.
 */
export const BroadcastToRoomChatMessageSchema: GenMessage<BroadcastToRoomChatMessage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 16);

/**
 * @generated from message plugnmeet.BroadcastToRoomNotificationMsg
 */
export type BroadcastToRoomNotificationMsg = Message<"plugnmeet.BroadcastToRoomNotificationMsg"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: plugnmeet.NatsSystemNotificationTypes type = 2;
   */
  type: NatsSystemNotificationTypes;

  /**
   * @generated from field: bool with_sound = 3;
   */
  withSound: boolean;
};

/**
 * Describes the message plugnmeet.BroadcastToRoomNotificationMsg.
 * Use `create(BroadcastToRoomNotificationMsgSchema)` to create a new message.
 */
export const BroadcastToRoomNotificationMsgSchema: GenMessage<BroadcastToRoomNotificationMsg> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_room, 17);

